var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "mb-4"
  }, [_c('CustomNav', {
    attrs: {
      "items": _vm.navItems
    },
    on: {
      "item-click": function itemClick(val) {
        return _vm.viewMenu = val;
      }
    }
  })], 1), _vm.viewMenu == 'category' ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("List Master Data Category")])])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-form', {
          staticClass: "row w-100",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.getInspectionChecklistCategory();
            }
          }
        }, [_c('b-col', {
          staticClass: "p-0",
          attrs: {
            "cols": "12",
            "md": "10"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "text",
            "placeholder": "Search..."
          },
          model: {
            value: _vm.categoryList.params.name,
            callback: function callback($$v) {
              _vm.$set(_vm.categoryList.params, "name", $$v);
            },
            expression: "categoryList.params.name"
          }
        })], 1), _c('b-col', {
          staticClass: "p-0",
          attrs: {
            "cols": "12",
            "md": "2"
          }
        }, [_c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_vm.categoryList._loading ? _c('div', {
          staticClass: "text-center my-5"
        }, [_c('b-spinner', {
          attrs: {
            "type": "grow",
            "label": "Spinning"
          }
        })], 1) : [_vm.categoryList.data && _vm.categoryList.data.length > 0 ? _c('div', {
          staticClass: "table-responsive"
        }, [_c('table', {
          staticClass: "table table-striped"
        }, [_c('thead', [_c('tr', [_c('th', {
          attrs: {
            "width": "10%"
          }
        }, [_vm._v("No")]), _c('th', {
          staticClass: "text-truncate",
          staticStyle: {
            "min-width": "300px"
          }
        }, [_vm._v("Name")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Alias")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Vehicle Type")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Maintenance Component")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Vehicle Type Section")]), _c('th', {
          staticClass: "text-truncate"
        }, [_vm._v("Status")]), _c('th', {
          staticClass: "text-truncate text-center",
          attrs: {
            "width": "15%"
          }
        }, [_vm._v("Action")])])]), _c('tbody', _vm._l(_vm.categoryList.data, function (p, i) {
          var _p$vehicle_type, _p$maintenance_compon, _p$maintenance_compon2, _p$vehicle_type_secti, _p$vehicle_type_secti2;
          return _c('tr', {
            key: "p-".concat(i)
          }, [_c('td', [_vm._v(_vm._s(i + 1))]), _c('td', {
            class: "".concat(!p.parent_id ? 'font-weight-bold' : ''),
            staticStyle: {
              "min-width": "300px"
            }
          }, [_vm._v(_vm._s(p.name))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s(_vm.parseStr(p.alias)))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s(_vm.parseStr((_p$vehicle_type = p.vehicle_type) === null || _p$vehicle_type === void 0 ? void 0 : _p$vehicle_type.name)))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s((_p$maintenance_compon = (_p$maintenance_compon2 = p.maintenance_component) === null || _p$maintenance_compon2 === void 0 ? void 0 : _p$maintenance_compon2.component_name) !== null && _p$maintenance_compon !== void 0 ? _p$maintenance_compon : '-'))]), _c('td', {
            staticClass: "text-truncate text-center"
          }, [_vm._v(_vm._s((_p$vehicle_type_secti = (_p$vehicle_type_secti2 = p.vehicle_type_section) === null || _p$vehicle_type_secti2 === void 0 ? void 0 : _p$vehicle_type_secti2.name) !== null && _p$vehicle_type_secti !== void 0 ? _p$vehicle_type_secti : '-'))]), _c('td', {
            staticClass: "text-truncate"
          }, [_vm._v(_vm._s(p.status ? 'Active' : 'Inactive'))]), _c('td', [_c('div', {
            staticClass: "d-flex"
          }, [_c('b-button', {
            staticClass: "mr-2",
            attrs: {
              "variant": "success",
              "size": "sm"
            },
            on: {
              "click": function click($event) {
                return _vm.editFormCategory(p);
              }
            }
          }, [_c('i', {
            staticClass: "fa fa-edit"
          })]), _c('b-button', {
            attrs: {
              "variant": "danger",
              "size": "sm"
            },
            on: {
              "click": function click($event) {
                return _vm.onDeleteCategory(p);
              }
            }
          }, [!_vm.delete_category ? _c('i', {
            staticClass: "fa fa-trash"
          }) : [_c('span', {
            staticClass: "spinner-border spinner-border-sm",
            attrs: {
              "role": "status",
              "aria-hidden": "true"
            }
          }), _vm._v("Deleting... ")]], 2)], 1)])]);
        }), 0)])]) : _vm._e(), _vm.categoryList.data && _vm.categoryList.data.length > 0 ? _c('div', [_c('b-pagination', {
          attrs: {
            "total-rows": _vm.categoryList.meta.totalItem,
            "per-page": _vm.categoryList.meta.perPage,
            "first-number": "",
            "align": "center"
          },
          on: {
            "change": _vm.getInspectionChecklistCategory
          },
          model: {
            value: _vm.categoryList.meta.page,
            callback: function callback($$v) {
              _vm.$set(_vm.categoryList.meta, "page", $$v);
            },
            expression: "categoryList.meta.page"
          }
        })], 1) : _c('p', {
          staticClass: "text-center my-4"
        }, [_vm._v("No Category data found.")])]];
      },
      proxy: true
    }], null, false, 2256041884)
  })], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('iq-card', {
    class: {
      'border border-danger shadow-lg': _vm.category_edit
    },
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v(_vm._s(_vm.category_edit ? 'Edit' : 'Add') + " Category")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.onSaveCategory();
            }
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Category",
            "label-for": "name"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "text",
            "placeholder": "Type text"
          },
          model: {
            value: _vm.formCategory.name,
            callback: function callback($$v) {
              _vm.$set(_vm.formCategory, "name", $$v);
            },
            expression: "formCategory.name"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Parent",
            "label-for": "parent_id"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "options": _vm.listParent,
            "reduce": function reduce(obj) {
              return obj.value;
            },
            "placeholder": "Select parent"
          },
          model: {
            value: _vm.formCategory.parent_id,
            callback: function callback($$v) {
              _vm.$set(_vm.formCategory, "parent_id", $$v);
            },
            expression: "formCategory.parent_id"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Alias",
            "label-for": "alias"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "alias",
            "type": "text",
            "placeholder": "Type text",
            "maxlength": "30"
          },
          model: {
            value: _vm.formCategory.alias,
            callback: function callback($$v) {
              _vm.$set(_vm.formCategory, "alias", $$v);
            },
            expression: "formCategory.alias"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Vehicle Type",
            "label-for": "vehicle_type_id"
          }
        }, [_c('v-select', {
          attrs: {
            "options": _vm.optionsVehicleType,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text",
            "clearable": false,
            "placeholder": "Select..."
          },
          model: {
            value: _vm.formCategory.vehicle_type_id,
            callback: function callback($$v) {
              _vm.$set(_vm.formCategory, "vehicle_type_id", $$v);
            },
            expression: "formCategory.vehicle_type_id"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Maintenance Component",
            "label-for": "maintenance_component_id"
          }
        }, [_c('v-select', {
          attrs: {
            "options": _vm.optionsMaintenanceComponent,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text",
            "clearable": false,
            "placeholder": "Select...",
            "disabled": !_vm.formCategory.vehicle_type_id
          },
          model: {
            value: _vm.formCategory.maintenance_component_id,
            callback: function callback($$v) {
              _vm.$set(_vm.formCategory, "maintenance_component_id", $$v);
            },
            expression: "formCategory.maintenance_component_id"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Vehicle Type Section",
            "label-for": "vehicle_type_m_section_id"
          }
        }, [_c('v-select', {
          attrs: {
            "options": _vm.listVehicleTypeMasterSection,
            "reduce": function reduce(option) {
              return option.value;
            },
            "label": "text",
            "clearable": false,
            "placeholder": "Select..."
          },
          model: {
            value: _vm.formCategory.vehicle_type_m_section_id,
            callback: function callback($$v) {
              _vm.$set(_vm.formCategory, "vehicle_type_m_section_id", $$v);
            },
            expression: "formCategory.vehicle_type_m_section_id"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Status",
            "label-for": "status"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          model: {
            value: _vm.formCategory.status,
            callback: function callback($$v) {
              _vm.$set(_vm.formCategory, "status", $$v);
            },
            expression: "formCategory.status"
          }
        }, [_vm._v("Active / Inactive ")])], 1), _c('hr'), _c('b-form-group', {
          staticClass: "text-right"
        }, [_c('b-button', {
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [!_vm.category_edit ? _c('span', [_vm._v("Add")]) : _c('span', [_vm._v("Save Edit")])]), _c('b-button', {
          staticClass: "iq-bg-danger ml-3",
          attrs: {
            "type": "button",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.resetFormCategory();
            }
          }
        }, [_vm._v("Cancel")])], 1)], 1)];
      },
      proxy: true
    }], null, false, 3538774605)
  })], 1)], 1) : _vm._e(), _vm.viewMenu == 'question' ? _c('b-row', [_c('b-col', {
    attrs: {
      "sm": "8"
    }
  }, [_c('iq-card', {
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title text-primary"
        }, [_c('strong', [_vm._v("List Master Data Question")])])];
      },
      proxy: true
    }, {
      key: "headerAction",
      fn: function fn() {
        return [_c('b-form', {
          staticClass: "row w-100",
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.getInspectionChecklistQuestion();
            }
          }
        }, [_c('b-col', {
          staticClass: "p-0",
          attrs: {
            "cols": "12",
            "md": "10"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "name",
            "type": "text",
            "placeholder": "Search..."
          },
          model: {
            value: _vm.questionList.params.question,
            callback: function callback($$v) {
              _vm.$set(_vm.questionList.params, "question", $$v);
            },
            expression: "questionList.params.question"
          }
        })], 1), _c('b-col', {
          staticClass: "p-0",
          attrs: {
            "cols": "12",
            "md": "2"
          }
        }, [_c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [_c('i', {
          staticClass: "fa fa-search"
        })])], 1)], 1)];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_vm.questionList._loading ? _c('div', {
          staticClass: "text-center my-5"
        }, [_c('b-spinner', {
          attrs: {
            "type": "grow",
            "label": "Spinning"
          }
        })], 1) : [_vm.questionList.data && _vm.questionList.data.length > 0 ? _c('div', [_c('div', {
          staticClass: "table-responsive"
        }, _vm._l(_vm.questionList.data, function (parentQuestion, parentQuestionIndex) {
          var _parentQuestion$inspe, _parentQuestion$inspe2;
          return _c('table', {
            key: parentQuestionIndex,
            staticClass: "table table-striped"
          }, [_c('thead', [!parentQuestion.parent_id && (parentQuestion === null || parentQuestion === void 0 ? void 0 : (_parentQuestion$inspe = parentQuestion.inspection_checklist_question) === null || _parentQuestion$inspe === void 0 ? void 0 : _parentQuestion$inspe.length) <= 0 ? _c('tr', [_c('th', {
            staticClass: "align-middle text-center bg-secondary",
            attrs: {
              "colspan": "6"
            }
          }, [_vm._v(_vm._s(parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.name))])]) : _c('tr', {
            staticStyle: {
              "cursor": "pointer"
            },
            on: {
              "click": function click($event) {
                return _vm.toggleRow("row-".concat(parentQuestionIndex));
              }
            }
          }, [_c('th', {
            staticStyle: {
              "width": "5px"
            }
          }, [_vm._v("No")]), _c('th', {
            staticClass: "text-truncate",
            staticStyle: {
              "max-width": "100px"
            }
          }, [_vm._v(_vm._s(parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.name))]), _c('th', {
            staticStyle: {
              "width": "150px"
            }
          }, [_vm._v("Alias")]), _c('th', {
            staticStyle: {
              "width": "150px"
            }
          }, [_vm._v("Status")]), _c('th', {
            staticClass: "text-center",
            staticStyle: {
              "width": "5px"
            }
          }, [_vm._v("#")])])]), (parentQuestion === null || parentQuestion === void 0 ? void 0 : (_parentQuestion$inspe2 = parentQuestion.inspection_checklist_question) === null || _parentQuestion$inspe2 === void 0 ? void 0 : _parentQuestion$inspe2.length) > 0 ? _c('tbody', [_vm.isRowVisible("row-".concat(parentQuestionIndex)) ? _vm._l(parentQuestion === null || parentQuestion === void 0 ? void 0 : parentQuestion.inspection_checklist_question, function (question, questionId) {
            return _c('tr', {
              key: questionId
            }, [_c('td', [_vm._v(_vm._s(questionId + 1))]), _c('td', [_vm._v(_vm._s(question.question))]), _c('td', [_vm._v(_vm._s(question.alias))]), _c('td', {
              class: question.status ? 'text-success' : 'text-danger'
            }, [_vm._v(_vm._s(question.status ? 'Active' : 'Inactive'))]), _c('td', [_c('div', {
              staticClass: "d-flex"
            }, [_c('b-button', {
              staticClass: "mr-2",
              attrs: {
                "variant": "success",
                "size": "sm"
              }
            }, [_c('i', {
              staticClass: "fa fa-edit",
              on: {
                "click": function click($event) {
                  return _vm.editFormQuestion(question);
                }
              }
            })]), _c('b-button', {
              attrs: {
                "variant": "danger",
                "size": "sm"
              },
              on: {
                "click": function click($event) {
                  return _vm.onDeleteQuestion(question);
                }
              }
            }, [!_vm.delete_question ? _c('i', {
              staticClass: "fa fa-trash"
            }) : [_c('span', {
              staticClass: "spinner-border spinner-border-sm",
              attrs: {
                "role": "status",
                "aria-hidden": "true"
              }
            }), _vm._v("Deleting... ")]], 2)], 1)])]);
          }) : _vm._e()], 2) : _vm._e()]);
        }), 0)]) : _c('p', {
          staticClass: "text-center my-4"
        }, [_vm._v("No Question data found.")])]];
      },
      proxy: true
    }], null, false, 3969538715)
  })], 1), _c('b-col', {
    attrs: {
      "sm": "4"
    }
  }, [_c('iq-card', {
    class: {
      'border border-danger shadow-lg': _vm.question_edit
    },
    scopedSlots: _vm._u([{
      key: "headerTitle",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "card-title"
        }, [_vm._v(_vm._s(_vm.question_edit ? 'Edit' : 'Add') + " Question")])];
      },
      proxy: true
    }, {
      key: "body",
      fn: function fn() {
        return [_c('b-form', {
          on: {
            "submit": function submit($event) {
              $event.preventDefault();
              return _vm.onSaveQuestion();
            }
          }
        }, [_c('b-form-group', {
          attrs: {
            "label": "Question",
            "label-for": "question"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "question",
            "type": "text",
            "placeholder": "Type text"
          },
          model: {
            value: _vm.formQuestion.question,
            callback: function callback($$v) {
              _vm.$set(_vm.formQuestion, "question", $$v);
            },
            expression: "formQuestion.question"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Alias",
            "label-for": "alias"
          }
        }, [_c('b-form-input', {
          attrs: {
            "id": "alias",
            "type": "text",
            "placeholder": "Type text",
            "maxlength": "30"
          },
          model: {
            value: _vm.formQuestion.alias,
            callback: function callback($$v) {
              _vm.$set(_vm.formQuestion, "alias", $$v);
            },
            expression: "formQuestion.alias"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Checklist Category",
            "label-for": "checklist_category_id"
          }
        }, [_c('v-select', {
          attrs: {
            "label": "text",
            "options": _vm.listCategory,
            "reduce": function reduce(obj) {
              return obj.value;
            },
            "placeholder": "Select checklist category",
            "required": ""
          },
          model: {
            value: _vm.formQuestion.checklist_category_id,
            callback: function callback($$v) {
              _vm.$set(_vm.formQuestion, "checklist_category_id", $$v);
            },
            expression: "formQuestion.checklist_category_id"
          }
        })], 1), _c('b-form-group', {
          attrs: {
            "label": "Status",
            "label-for": "status"
          }
        }, [_c('b-form-checkbox', {
          attrs: {
            "name": "check-button",
            "switch": "",
            "inline": ""
          },
          model: {
            value: _vm.formQuestion.status,
            callback: function callback($$v) {
              _vm.$set(_vm.formQuestion, "status", $$v);
            },
            expression: "formQuestion.status"
          }
        }, [_vm._v("Active / Inactive ")])], 1), _c('hr'), _c('b-form-group', {
          staticClass: "text-right"
        }, [_c('b-button', {
          attrs: {
            "type": "submit",
            "variant": "primary"
          }
        }, [_vm.saving_question ? _c('span', {
          staticClass: "spinner-border spinner-border-sm"
        }) : !_vm.question_edit && !_vm.saving_question ? _c('span', [_vm._v("Add")]) : _vm.question_edit && !_vm.saving_question ? _c('span', [_vm._v("Save Edit")]) : _vm._e()]), _c('b-button', {
          staticClass: "iq-bg-danger ml-3",
          attrs: {
            "type": "button",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return _vm.resetFormQuestion();
            }
          }
        }, [_vm._v("Cancel")])], 1)], 1)];
      },
      proxy: true
    }], null, false, 627306777)
  })], 1)], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }